/**
 * classifyTimeAbove.js : palier de la part du temps passée au-dessus du seuil
 * d'avertissement (D3, retours du 3 avril 2026, cf. SessionStats) : elle évite que
 * la moyenne masque des épisodes courts mais intenses.
 *
 * Bornes : moins de 5 % → 'low' (normal), 5 à 10 % inclus → 'mid' (à
 * surveiller), plus de 10 % → 'high' (élevé). Centralisées ici depuis
 * 10.5.313 (D239) : la ligne des cartes, sa couleur et la légende les lisent.
 */
export const TIME_ABOVE_PCT = Object.freeze({ watchFrom: 5, highAbove: 10 });

/**
 * @param {number|null} pct  Part du temps mesuré au-dessus du seuil, en %.
 * @returns {'low'|'mid'|'high'|null}  null si la part n'est pas un nombre fini.
 */
export function classifyTimeAbove(pct) {
  if (typeof pct !== 'number' || !Number.isFinite(pct)) return null;
  if (pct < TIME_ABOVE_PCT.watchFrom) return 'low';
  if (pct <= TIME_ABOVE_PCT.highAbove) return 'mid';
  return 'high';
}
